/**
 * Demo-mode gating.
 *
 * Demo credential hints (Contest Judge / Diani Plate) must NOT leak on the
 * production build. They are shown only when the app is opened with `?demo=1`.
 * The flag is persisted to localStorage so it survives client-side navigation
 * within the demo deployment; `?demo=0` clears it.
 */
const STORAGE_KEY = "hp_demo";

export function isDemoMode() {
  try {
    const params = new URLSearchParams(window.location.search);
    const flag = params.get("demo");
    if (flag === "1") {
      localStorage.setItem(STORAGE_KEY, "1");
      return true;
    }
    if (flag === "0") {
      localStorage.removeItem(STORAGE_KEY);
      return false;
    }
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}
